{
  "alert": "Varsel",
  "dismiss": "Lukk"
}
